'use strict';

export function getHeader() {
  const header = document.querySelector('.header-site-wide');
  const assemblyHeader = document.querySelector('[data-assembly-source="browse-ui/header"]');

  return header || assemblyHeader
}

export function isPeepHeader() {
  const header = getHeader();

  const isPeepHeader = header?header.querySelector('[class*="mobile-header-peepHeader"]'):false;

  return isPeepHeader;
}

export function getSearchForm() {
  return document.querySelector('[data-search-form]');
}

export function isPersistentSearch() {
  const searchForm = getSearchForm();

  if(!searchForm) {
    return false
  }

  return searchForm.getAttribute('data-persistent-search') === 'true';
}
